export default {
    ready: false,
    lastCode: '',
    keys: [],
    prefix: 'PP',
    initListener() {
        if (this.ready === false) {
            this.ready = true
            window.addEventListener('focus', function () {
                Core.Scan.onFocus()
            })
            window.addEventListener('blur', function () {
                Core.Scan.onBlur()
            })
            let keyPressFunc = function (event) {
                let key = event.key
                let keyCode = event.keyCode
                if (keyCode !== 16) {
                    if (keyCode === 13) {
                        Core.Scan.eval()
                    } else {
                        Core.Scan.keys.push(key)
                    }
                }
            }

            document.removeEventListener('keypress', keyPressFunc)
            document.addEventListener('keypress', keyPressFunc)
        }
    },
    onFocus: function (event) {
        this.ready = true
    },
    onBlur: function (event) {
        this.ready = false
    },
    eval() {
        if (Core.Scan.keys.length > 0) {
            let code = Core.Scan.keys.join('')
            if (code.substr(0, this.prefix.length-1) === this.prefix) {
                Core.Scan.lastCode = code
                Core.Scan.keys = []
            }
        }
    },
}